import * as Vuex from "vuex";
import { RtpEngine } from "@/entities/rtp-engine";
import { client } from "@/lib/client";
import { handleStoreError } from "@/lib/error";

const RtpEngineModule: Vuex.Module<RtpEngineStoreState, {}> = {
  state: {
    listRtpEngine: [],
  },
  getters: {
    RtpEngineTable(state) {
      return state.listRtpEngine;
    },
  },
  mutations: {
    SET_RTP_ENGINE_TABLE(state, payload: RtpEngine[]) {
      state.listRtpEngine = payload;
    },
    ADD_RTP_ENGINE(state, payload: RtpEngine[]) {
      state.listRtpEngine = payload;
    },
  },
  actions: {
    async getAllRtpEngine({ commit }) {
      const responseRtpEngine = await client
        .get("rpengine")
        .json<RtpEngine[]>();
      if (Array.isArray(responseRtpEngine)) {
        if (responseRtpEngine.length > 0 && responseRtpEngine[0].ID != 0) {
          commit("SET_RTP_ENGINE_TABLE", responseRtpEngine);
        } else {
          commit("SET_RTP_ENGINE_TABLE", []);
        }
      }
    },
    async addInstances({ commit }, nInstances: string) {
      await client
        .put(`rtpengine/${nInstances}`)
        .then(() => {
          commit("ADD_RTP_ENGINE");
        })
        .catch(handleStoreError(undefined, true));
    },
  },
  namespaced: true,
};

type RtpEngineStoreState = {
  listRtpEngine: RtpEngine[];
};
export default RtpEngineModule;
